import React, {useCallback, useState } from 'react';

export default function AvSettingModal(props) {

  const avSettings = props.avSettings;

  const audioInputDevices = avSettings.deviceList.audioInput;
  const videoInputDevices = avSettings.deviceList.videoInput;
  const audioOutputDevices = avSettings.deviceList.audioOutput;

  const [audioInput, setAudioInput] = useState(avSettings.audioInput);
  const [videoInput, setVideoInput] = useState(avSettings.videoInput);
  const [audioOutput, setAudioOutput] = useState(avSettings.audioOutput);

  const [autoGainControl, setAutoGainControl] = useState(false);
  const [noiseSuppression, setNoiseSuppression] = useState(false);
  const [echoCancellation, setEchoCancellation] = useState(false);

  const [audioGain, setAudioGain] = useState(avSettings.audioGain);
  const [isInitialized, setIsInitialized] = useState(false);

  const handleSelect = useCallback(async (e) => {
    const {name,value} = e.target;

    if (name === 'audioInput') {
      await props.setMediaDevice(name, value);
      setAudioInput(value); 
    }
    if (name === 'videoInput') {
      await props.setMediaDevice(name, value);
      setVideoInput(value); 
    }
    if (name === 'audioOutput') {
      await props.setMediaDevice(name, value);
      setAudioOutput(value); 
    }
  },[props]);


  const handleClick = useCallback (async (e) => {
    const {name} = e.target;
    if (name === 'autoGainControl') {
      await props.setAudioOption('autoGainControl', !autoGainControl);
      setAutoGainControl(!autoGainControl);
    }
    if (name === 'noiseSuppression') {
      await props.setAudioOption('noiseSuppression', !noiseSuppression);
      setNoiseSuppression(!noiseSuppression);
    }
    if (name === 'echoCancellation') {
      await props.setAudioOption('echoCancellation', !echoCancellation);
      setEchoCancellation(!echoCancellation); 
    }
  },[props,autoGainControl,noiseSuppression,echoCancellation]);

  const initialize = async () => {
    if (isInitialized) return;

    setIsInitialized(true);
    console.log('Modal initialize');

  try {

    if (avSettings.deviceList.audioInput.length > 0) {
      let ai = avSettings.deviceList.audioInput[0].id;
      if (audioInput) ai = audioInput;
      await props.setMediaDevice('audioInput', ai);
      setAudioInput(ai);
    }

    if (avSettings.deviceList.videoInput.length > 0) {
      let vi = avSettings.deviceList.videoInput[0].id;
      if (videoInput) vi = videoInput;
      await props.setMediaDevice('videoInput', vi);
      setVideoInput(vi);
    }

    if (avSettings.deviceList.audioOutput.length > 0) {
      let ao = avSettings.deviceList.audioOutput[0].id;
      if (audioOutput) ao = audioOutput;
      await props.setMediaDevice('audioOutput', ao);
      setAudioOutput(ao);
    }

     if (avSettings.micTrack){
       const c = avSettings.micTrack.getConstraints();
       console.log('Modal micTrack: ', c);
         setAutoGainControl(c.autoGainControl);
         setNoiseSuppression(c.noiseSuppression);
         setEchoCancellation(c.echoCancellation);
     }

   } catch (e) {console.error(e);}

  }

  initialize();

  return (
    <div>
    <b>AudioInput:</b> &emsp;
      <select name="audioInput" value={audioInput} onChange={handleSelect}>
     {/* <option value={undefined}>Select audioInput</option> */}
      {audioInputDevices.map((device, index) =>
         <option key={index} value={device.id} >{device.label}</option>)}
      </select><br/><br/>
    Gain: &nbsp; <input type="range" value={audioGain} 
      min="0" max="200" onChange={(e) => {
        setAudioGain(e.target.value); props.setAudioGain(e.target.value);
       }
     } 
     style={{width: '60%'}} />&nbsp; {audioGain} <br/><br/>
    <span><button name="autoGainControl" 
      style={{backgroundColor: autoGainControl ? '#55ff55' : '#eeeeee' }}
      onClick={handleClick} > AutoGain</button>&emsp;
    <button name="noiseSuppression" 
      style={{backgroundColor: noiseSuppression ? '#55ff55' : '#eeeeee' }}
      onClick={handleClick}> NoiseSuppression</button>&emsp;
    <button name="echoCancellation" 
      style={{backgroundColor: echoCancellation ? '#55ff55' : '#eeeeee' }}
      onClick={handleClick} > EchoCancellation</button><br/><br/>
    </span>
    <b>VideoInput:</b> &emsp;
      <select name="videoInput" value={videoInput} onChange={handleSelect}>
       {videoInputDevices.map((device, index) =>
        <option key={index} value={device.id} >{device.label}</option>)}
      </select><br/><br/>
    <b>AudioOutput:</b> &emsp;
      <select name="audioOutput" value={audioOutput} onChange={handleSelect}>
      {audioOutputDevices.map((device, index) =>
        <option key={index} value={device.id} >{device.label}</option>)}
      </select>
    <hr />
    <button name="close" onClick={()=>props.close()} 
      style={{float: 'right'}}>Close</button>&emsp;
    {/*
    <button name="resolve" onClick={handleResolve}>OK</button>
    */}
    </div>
  );

}
